// Detecting a newer deploy from inside a running tab.
//
// index.html always revalidates (public/_headers) and names the
// content-hashed entry bundle, so comparing the entry script this page is
// running against the one the server serves right now says whether a
// redeploy has happened since the tab loaded. Safari's back/forward cache
// revives tabs across deploys without ever refetching the shell — during
// team formation that put staff on a scanner build that was hours stale.

export function entryFromHtml(html) {
  const match = String(html || "").match(/assets\/index-[\w-]+\.js/);
  return match ? match[0] : null;
}

export function runningEntry(doc = document) {
  for (const script of doc.querySelectorAll("script[src]")) {
    const match = (script.getAttribute("src") || "").match(/assets\/index-[\w-]+\.js/);
    if (match) return match[0];
  }
  // The dev server loads /src/main.jsx unhashed; there is nothing to
  // compare, so the update check stays off.
  return null;
}
